module.exports = __webpack_public_path__ + "static/docx.c8fb60063316dc015962021bce731d12.png";